import ReactPlayer from "react-player";

export function SupportVideoPlayer(props: { url: string }) {
  return (
    <ReactPlayer
      url={props.url}
      playsinline={true}
      controls={true}
      volume={1}
      width="100%"
      // height="100%"
      // playing={true}
      config={{
        vimeo: {
          playerOptions: {
            cc: true,
          },
        },
      }}
    />
  );
}
